var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52197 11.7671C6.9209 14.166 9.83447 16.0171 12.2168 16.0171C13.2876 16.0171 14.2256 15.6436 14.981 14.8135C15.4209 14.3237 15.6948 13.751 15.6948 13.1865C15.6948 12.7715 15.5371 12.373 15.147 12.0908L12.5986 10.2812C12.2085 10.0156 11.8848 9.88281 11.5859 9.88281C11.2124 9.88281 10.8721 10.0986 10.4902 10.4722L9.90088 11.0532C9.80957 11.1445 9.69336 11.186 9.58545 11.186C9.46094 11.186 9.33643 11.1362 9.25342 11.0947C8.73877 10.8208 7.85889 10.0654 7.03711 9.25195C6.22363 8.43848 5.46826 7.55859 5.20264 7.04395C5.16113 6.95264 5.11133 6.83643 5.11133 6.71191C5.11133 6.604 5.14453 6.49609 5.23584 6.40479L5.8252 5.79883C6.19043 5.41699 6.41455 5.08496 6.41455 4.70312C6.41455 4.4043 6.27344 4.08057 5.99951 3.69043L4.21484 1.17529C3.92432 0.776855 3.51758 0.602539 3.06934 0.602539C2.52148 0.602539 1.95703 0.851562 1.46729 1.32471C0.662109 2.09668 0.305176 3.05127 0.305176 4.10547C0.305176 6.48779 2.12305 9.37646 4.52197 11.7671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneUp);
export default __webpack_public_path__ + "static/media/phone_up.e2593a92a4c18b9d0c2c3ca9dc1a0ebd.svg";
export { ForwardRef as ReactComponent };